module.exports = __webpack_public_path__ + "static/img/process2.33f95cd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/process2.jpg
// module id = 516
// module chunks = 2 3